<template>
  <v-expansion-panel
    v-model="expansionPanel"
    class="v-expansion-panel_inlined"
  >
    <v-expansion-panel-content>
      <template slot="header">
        <v-layout align-center>
          <baseIcon
            :width="32"
            :height="32"
            class="mr-3"
          >
            <storeIcon :icon-color="$vuetify.theme.sz_medium_grey" />
          </baseIcon>
          {{ $t('warehouses.details') }}
        </v-layout>
      </template>
      <v-card>
        <v-divider />
        <v-layout
          class="mt-4 align-stretch volunteers"
          wrap
        >
          <v-flex xs12>
            <v-layout mb-3>
              <v-flex xs4>
                <h3 class="display-2 display-2_dark mb-2">
                  {{ $t('warehouses.locationData.title') }}
                </h3>
              </v-flex>
              <v-flex
                xs8
                mt-2
              >
                <v-layout wrap>
                  <v-flex
                    sm6
                    xs12
                    class="px-2"
                  >
                    <p class="display-1 display-1_dark mb-2">
                      {{ $t('label.address') }}
                    </p>
                    <p class="mb-0 f-16">
                      {{ warehouse.location_name }}
                    </p>
                    <p class="mb-0 f-16">
                      {{ fullStreet(warehouse) }}
                    </p>
                    <p class="f-16">
                      {{ fullCity(warehouse) }}
                    </p>
                  </v-flex>
                  <v-flex
                    sm6
                    xs12
                    class="px-2"
                  >
                    <p class="display-1 display-1_dark mb-2">
                      {{ $t('warehouses.locationData.warehouse_opening') }}
                    </p>
                    <p
                      v-for="(item, index) in getOpeningHours"
                      :key="index"
                      class="mb-0 f-16"
                    >
                      {{ item }}
                    </p>
                  </v-flex>
                  <v-flex
                    sm6
                    xs12
                    class="px-2"
                    mt-3
                  >
                    <p class="display-1 display-1_dark mb-2">
                      {{ $t('warehouses.preview.directions') }}
                    </p>
                    <p class="f-16 mb-2">
                      {{ warehouse.warehouse_data.location_data.directions }}
                    </p>
                    <p
                      v-if="isTruckAccess"
                      class="f-16"
                    >
                      <v-icon :color="$vuetify.theme.sz_green">
                        check
                      </v-icon>
                      {{ $t('warehouses.preview.truck_access') }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-divider />
          </v-flex>
          <v-flex
            xs12
            mt-4
          >
            <v-layout>
              <v-flex xs4>
                <h3 class="display-2 display-2_dark mb-2">
                  {{ $t('warehouses.additional_parameters.title') }}
                </h3>
              </v-flex>
              <v-flex
                xs8
                mt-2
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    class="px-2"
                  >
                    <p class="display-1 display-1_dark mb-2">
                      {{ $t('warehouses.capacity') }}:
                    </p>
                    <p class="mb-0 f-16">
                      {{ warehouse.warehouse_data.additional_parameters.size }} m2
                    </p>
                  </v-flex>
                  <v-flex
                    v-if="inWarehouse.length > 0"
                    xs12
                    class="px-2 mt-3"
                  >
                    <p class="display-1 display-1_dark mb-2">
                      {{ $t('warehouses.at_location') }}:
                    </p>
                    <ul>
                      <li
                        v-for="(item, index) in inWarehouse"
                        :key="index"
                        class="mb-0 f-16"
                      >
                        {{ item.description }}
                      </li>
                    </ul>
                    <p
                      v-if="
                        warehouse.warehouse_data.additional_parameters.warehouseOperation != null
                      "
                      class="mb-0 f-16 mt-2"
                    >
                      {{ warehouse.warehouse_data.additional_parameters.warehouseOperation }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import filters from '@/constants/filters';
import storeIcon from '@/icons/StoreIcon';

export default {
    name: 'WarehouseDetails',
    components: { baseIcon, storeIcon },
    filters: {
        ...filters
    },
    props: {
        warehouse: {
            default: null
        },
        resource: {
            default: null
        }
    },
    data () {
        return {
            expansionPanel: 0
        };
    },
    computed: {
        openingDays () {
            return this.resource.find((el) => {
                return el.id === 1003;
            }).resources;
        },
        openingData () {
            return this.warehouse.warehouse_data.location_data.opening_hours;
        },
        getOpeningHours () {
            const bind = [
                { id: 327, from: 'firstDayFrom', to: 'firstDayTo' },
                { id: 328, from: 'secondDayFrom', to: 'secondDayTo' },
                { id: 329, from: 'thirdDayFrom', to: 'thirdDayTo' }
            ];
            const array = [];
            for (const key in bind) {
                let day = this.openingDays.find((el) => {
                    return el.id === bind[key].id;
                }).description;
                const openingFrom = this.$options.filters.timeInput(this.openingData[bind[key].from]);
                const openingTo = this.$options.filters.timeInput(this.openingData[bind[key].to]);
                if (openingFrom === '' && openingTo === '') {
                    continue;
                }
                day = day + ' ' + openingFrom + ' - ' + openingTo;
                array.push(day);
            }
            return array;
        },
        isTruckAccess () {
            return this.warehouse.warehouse_data.additional_parameters.truckAccess === 'yes';
        },
        resourcesInWarehouse () {
            return this.resource.find((el) => {
                return el.id === 1002;
            }).resources;
        },
        inWarehouse () {
            if (this.warehouse.warehouse_data.additional_parameters.warehousePotential === 'no') {
                return [];
            }
            const id = this.warehouse.warehouse_data.additional_parameters.warehouseEquipment;
            return this.resourcesInWarehouse.filter((el) => {
                return id.includes(el.id);
            });
        }
    },
    methods: {
        fullStreet (item) {
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            const _street = item.street ? item.street : '';
            return _street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        }
    }
};
</script>

<style scoped></style>
